export const registerConstants = {
  SET_PLANS: 'SET_PLANS',
  SET_WAIT_EMAIL_VERIFY: 'SET_WAIT_EMAIL_VERIFY',
  SET_IS_REGISTER_LOADING: 'SET_IS_REGISTER_LOADING',
  SET_BILLING_COUNTRY: 'SET_BILLING_COUNTRY',
  SET_CHECKOUT_DETAILS: 'SET_CHECKOUT_DETAILS',
  SET_PROMO_CODE: 'SET_PROMO_CODE',
  SET_REFERRAL_CODE: 'SET_REFERRAL_CODE'
};
